import React, { useState } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone, Alert } from '@helpers';

import { SmallLoading } from '@components/loading';
import TouchableElement from '@components/common/touchableElement';
import EditableLine from '@components/common/editableLine';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

export default ({ C, setData, updateData, data, goBack, addMachineAction, setMode, MODES, getMachineFromHistory }) => {
  const [loading, setLoading] = useState(false);
  const submitDisabled = !data.fullName || !data.shortName || loading;

  const inputs = [
    {
      key: 'endpoint',
      name: 'Host/IP',
      noArrow: true,
      isLable: true,
      editable: false,
    },
    {
      key: 'fullName',
      name: 'Machine Name',
      placeholder: 'Required',
      noArrow: true,
      isLable: true,
      onChange: (v) => {
        setData({
          ...data,
          fullName: v,
          shortName: v ? v.slice(0, 20) : '',
        });
      },
    },
  ];

  const submit = async () => {
    setLoading(true);
    console.log(data, 'data');
    if (!data.machineId) {
      const historyMachine = await getMachineFromHistory(data);
      if (historyMachine?.[0]?.machineId) {
        setData({
          ...data,
          historyMachines: historyMachine,
          historyMachine: historyMachine[0],
        });
        setMode(MODES.SAME_MACHINE);
        setLoading(false);
        return;
      }
    }

    await addMachineAction(data);

    setLoading(false);
  };

  return (
    <View>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            <TouchableElement
              onPress={() => {
                goBack();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), flexDirection: 'row' }]}>
                  <View style={{ marginTop: scale(2) }}>
                    <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
                  </View>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Back')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
          <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
            <TouchableElement
              onPress={() => {
                if (submitDisabled) {
                  return;
                }
                submit();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15) }]}>
                  {loading ? (
                    <SmallLoading />
                  ) : (
                    <Text style={[{ color: C(pressHoverColor(submitDisabled ? 'Label/Light/Quinary' : 'Link/Light/Primary')) }, font.Headline]}>
                      {i18n.t('Done')}
                    </Text>
                  )}
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Add Machine')}</Text>
        </View>
      </View>
      <View style={{ marginTop: scale(20), marginBottom: scale(15), paddingHorizontal: isPhone ? 0 : scale(15) }}>
        {inputs.map((item, index) => (
          <EditableLine
            {...{
              item: {
                value: data[item.key] || '',
                onChange: (v) => updateData(item.key, v),
                small: false,
                ...item,
              },
              bg: modalFieldBg,
              index,
              array: inputs,
              C,
              bottomBorderBox: isPhone,
              topBorderBox: isPhone,
              topBorder: index !== 0,
              roundTop: !isPhone && index === 0,
              roundBottom: !isPhone && index === inputs.length - 1,
              editable: item.editable,
            }}
            key={item.key}
          />
        ))}
      </View>
      {data.fullName?.length > 20 && (
        <View style={{ marginTop: scale(13), paddingHorizontal: isPhone ? 0 : scale(15), marginBottom: scale(15) }}>
          <View style={{ paddingHorizontal: scale(15) }}>
            <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{i18n.t('MACHINE SHORT NAME')}</Text>
          </View>
          <View style={{ marginTop: scale(5) }}>
            <EditableLine
              {...{
                item: {
                  value: data.shortName,
                  key: 'shortName',
                  placeholder: 'Machine Short Name',
                  noArrow: true,
                  isLable: false,
                  small: false,
                  onChange: (v) => updateData('shortName', v),
                },
                bg: modalFieldBg,
                index: 0,
                array: [{}],
                C,
                bottomBorderBox: isPhone,
                topBorderBox: isPhone,
                roundTop: !isPhone,
                roundBottom: !isPhone,
              }}
            />
          </View>
          <View style={{ paddingHorizontal: scale(15), marginTop: scale(3) }}>
            <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>
              {i18n.t('We recommend a short machine name with 20 or less characters.')}
            </Text>
          </View>
        </View>
      )}
    </View>
  );
};
